import { useQuery } from '@tanstack/react-query';
import {
  DependentsWarning,
  DEFAULT_DEPENDENT_KIND_LABELS,
} from '@reflex/ui/components/shared/DependentsWarning';
import { api } from '@/lib/api';

/**
 * Delete-confirm body for an org model-provider key: warns which live agents,
 * personas, and projects are pinned to it before it's removed. Fetches only
 * while mounted (the manager renders it only when its delete dialog is open).
 */
export function OrgModelProviderSecretDeleteBody({
  orgId,
  secretId,
  name,
}: {
  orgId: string;
  secretId: string;
  name: string;
}) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['org', 'model-provider-secrets', orgId, secretId, 'dependents'] as const,
    queryFn: () => api.listOrgModelProviderSecretDependents(orgId, secretId),
    enabled: !!orgId && !!secretId,
  });
  return (
    <DependentsWarning
      resourceName={name}
      dependents={data?.dependents ?? []}
      isLoading={isLoading}
      isError={isError}
      kindLabels={DEFAULT_DEPENDENT_KIND_LABELS}
      impact="will fall back to another key on the next launch"
    />
  );
}
